import { service } from '@ember/service';
import Route from '@ember/routing/route';

// This route will be used to verify the payment link token, store the session
// and display the DOB verification page (BILL-1175)
// As for now, we will just display the session data and the DOB verification page later.
export default class PaymentLinkVerifyRoute extends Route {
  @service router;
  @service fastboot;
  @service currentPractice;
  @service store;
  @service signIn;

  paymentLinkSession = null;

  async beforeModel() {
    if (this.fastboot.isFastBoot) {
      return;
    }

    if (!this._areFeatureFlagsEnabled() || !this._getUrlToken()) {
      return this.router.transitionTo('not-found', 'errors/404');
    }

    // Create the payment link session
    let paymentLinkSession = this.store.createRecord('payment-link-session', {
      token: location.hash.substring(1),
    });

    // Verify the token and store the session
    let success = await this.signIn.verifyTokenTask.perform(paymentLinkSession);

    if (!success) {
      return this.router.transitionTo('site.expired-payment-link');
    }

    this.paymentLinkSession = paymentLinkSession;
  }

  _areFeatureFlagsEnabled() {
    return (
      this.currentPractice.get('featurePaymentLinksSms') &&
      this.currentPractice.get('featurePaymentLinks')
    );
  }

  _getUrlToken() {
    return location.hash && location.hash.length > 1 ? location.hash.substring(1) : null;
  }

  model() {
    return this.paymentLinkSession;
  }
}
